"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useEffect, useState } from "react";
import firstSlide from "@/assets/login/1.jpg";
import secondSlide from "@/assets/login/2.jpg";
import thirdSlide from "@/assets/login/3.jpg";
import fourthSlide from "@/assets/login/4.jpg";
const SLIDES = [{
  key: "first",
  image: firstSlide
}, {
  key: "second",
  image: secondSlide
}, {
  key: "third",
  image: thirdSlide
}, {
  key: "fourth",
  image: fourthSlide
}];
const SLIDE_DURATION_MS = 8000;
export const LoginBackground = () => {
  const $ = _c(6);
  const [activeIndex, setActiveIndex] = useState(0);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const timer = setInterval(() => setActiveIndex(_temp), SLIDE_DURATION_MS);
      return () => clearInterval(timer);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== activeIndex) {
    t2 = SLIDES.map((slide, index_0) => <Image key={slide.key} src={slide.image} alt="" fill={true} priority={index_0 === 0} unoptimized={true} sizes="100vw" className={`object-cover transition-opacity duration-1000 ${index_0 === activeIndex ? "opacity-100" : "opacity-0"}`} />);
    $[2] = activeIndex;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div aria-hidden={true} className="fixed inset-0 -z-10 bg-[#666]">{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
function _temp(index) {
  return (index + 1) % SLIDES.length;
}